import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {environment as env } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private refreshSubject = new Subject<void>();
  /** Fires when something just wrote a notification row and the bell should re-poll now. */
  public refresh$: Observable<void> = this.refreshSubject.asObservable();

  constructor(private http: HttpClient) { }

  public getReOptNotifications(): Observable<any> {
      return this.http.get<any>(`${env.apiBaseUrl}/reopt/notifications`);
  }

  /**
   * Ask the bell to re-poll immediately. The menu polls once a minute, which is fine
   * for pipeline jobs but leaves a send the user just made invisible for up to a
   * minute; callers that know a job row was written use this instead of waiting.
   */
  public refresh(): void {
      this.refreshSubject.next();
  }
}
